import useSWR from 'swr';
import { useEffect } from 'react';
import axios from '../services/axios';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

export const useAuth = ({ middleware, redirectIfAuthenticated } = {}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    data: user,
    error,
    mutate
  } = useSWR('/api/v2/auth/me', () =>
    axios
      .get('/api/v2/auth/me')
      .then((res) => {
        if (res.data.data) {
          setCurrentUser(res.data.data);
        }

        return res.data.data;
      })
      .catch((error) => {
        if (error.response.status !== 409) throw error;
      })
  );

  const setCurrentUser = (user) => {
    dispatch({
      type: 'SET_USER',
      current_user: user
    });
  };

  const login = async ({ setErrors, ...props }) => {
    setErrors([]);
    axios
      .post('/api/v2/auth/login', props)
      .then((res) => {
        console.log(res);
        // Сохраняем access_token и refresh_token
        if (res.data.access_token) {
          localStorage.setItem('access_token', res.data.access_token);
        }
        if (res.data.refresh_token) {
          localStorage.setItem('refresh_token', res.data.refresh_token);
        }
        mutate();
      })
      .catch((error) => {
        console.log(error);
        if (error.response.status !== 422) throw error;

        setErrors(error.response.data.errors);
      });
  };

  const loginByAuthLink = async ({ ...props }) => {
    try {
      const res = await axios.post('/api/v2/auth/one-time-auth', props);

      if (res.data.access_token) {
        localStorage.setItem('access_token', res.data.access_token);
      }
      if (res.data.refresh_token) {
        localStorage.setItem('refresh_token', res.data.refresh_token);
      }

      // Обновить кеш пользователя
      const userRes = await axios.get('/api/v2/auth/me');
      const currentUser = userRes?.data?.data;
      if (currentUser) {
        setCurrentUser(currentUser);
        await mutate(); // синхронизируем SWR

        // Редирект по роли
        switch (currentUser.role) {
          case 'admin':
            navigate('/dashboard');
            break;
          case 'vendor':
            navigate('/profile/edit');
            break;
          case 'client':
            navigate('/profile/edit');
            break;
          default:
            navigate('/'); // запасной маршрут
        }
      } else {
        // если не получили юзера — отправим на логин
        navigate('/login');
      }
    } catch (error) {
      console.log(error);
      if (error.response?.status !== 422) throw error;
    }
  };

  const logout = async () => {
    if (!error) {
      await axios.post('/api/v2/auth/logout').then(() => mutate());
    }
    // Удаляем токены
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    window.location.pathname = '/login';
  };
  useEffect(() => {
    if (middleware === 'guest' && redirectIfAuthenticated && user) {
      switch (user.role) {
        case 'admin':
          navigate('/dashboard');
          break;
        case 'vendor':
          navigate('/vendor/biddings');
          break;
        case 'client':
          navigate('/client/biddings');
          break;
      }
    }
    if (window.location.pathname === '/verify-email' && user?.email_verified_at) {
      history.push(redirectIfAuthenticated);
    }
    if (middleware === 'auth' && error) logout();
  }, [user, error]);

  return {
    user,
    login,
    loginByAuthLink,
    logout
  };
};
